<template>
  <a @click.stop="expand"
     class="d-inline-block d-md-none more-info">
    <ArrowSvg/>
  </a>
</template>

<script setup>
import ArrowSvg from '@/assets/svg-vue/warehouse/circlearrow.svg'

const expand = (e) => {
  let tr = e.target.closest('tr')
  if(tr) {
    tr.classList.toggle('expanded')
  }
}
</script>
